import { action } from 'mobx';
import { ACCESS_TOKEN } from '../api';
import { removeCookie } from '../utils/cookies';
export var logOut = action(function (store) {
    removeCookie(ACCESS_TOKEN);
    window.location = window.location.pathname;
});
